import React from "react";
import CommonForm from "../../../components/common/LoginForm/CommonForm";
import LockIcon from "@mui/icons-material/Lock";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ChangePasswordApi } from "../../../redux/action/UserAction";
import loginimg from "../../../assest/image/loginbkg.png";

export default function ChangePassword() {
  // Hooks for navigation and dispatching Redux actions
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Formik setup for handling form state, validation, and submission
  const formikchgpass = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().required("password is required"),
      confirmPassword: Yup.string().required("password is required"),
    }),
    onSubmit: (values) => {
      // Prepare payload and dispatch change password action
      const body = {
        old_password: values?.password,
        new_password: values?.confirmPassword,
      };
      dispatch(ChangePasswordApi(body, navigate));
    },
  });

  // Configuration object for the reusable CommonForm component
  const Resetform = {
    title: "Change Password",
    onsubmit: formikchgpass.handleSubmit,
    btnText: "Submit",
    onClick: formikchgpass.handleSubmit,
    backpath: "/",
    inputGroups: [
      {
        type: "password",
        placeholder: "Enter old password",
        name: "password",
        onChange: formikchgpass?.handleChange,
        icon: <LockIcon />,
        value: formikchgpass.values.password,
        error: formikchgpass.errors.password,
        touched: formikchgpass.touched.password,
      },
      {
        type: "password",
        placeholder: "Enter new password",
        name: "confirmPassword",
        onChange: formikchgpass?.handleChange,
        icon: <LockIcon />,
        value: formikchgpass.values.confirmPassword,
        error: formikchgpass.errors.confirmPassword,
        touched: formikchgpass.touched.confirmPassword,
      },
    ],
  };

  return (
    <div className="login-container">
      {/* Form Section */}
      <div className="login-form-container">{CommonForm(Resetform)}</div>

      {/* Image Section */}
      <div className="login-image-container">
        <img className="robot-image" alt="img" src={loginimg} />
      </div>
    </div>
  );
}
